<template>
  <div id="main-elem" class="main-elem">
    <h3 class="gray900 fw700 mb-4">Notification Settings</h3>
    <div class="dovemed-card mb-4">
      <div class="d-flex justify-content-between notification-setting__items">
        <div>
          <h5 class="gray900 fw700">Allow Notifications</h5>
          <p class="gray600">Stay up to date with notifications on activity that involves you, including mentions, messages, replies to your post and invitations.</p>
        </div>
        <a-switch
          class="pl-1 pr-1"
          :style="{
            transform: 'scale(0.7)',
            'min-width': '50px',
            background: !permission.notifications ? 'rgba(0,0,0,.25)' : getAlphaPrimaryColor(),
            '--P500C': getPrimaryColor().split(' ')[0],
          }"
          :checked="permission.notifications"
          :loading="loading"
          size="large"
          @change="changePermissions($event, 'allow_notifications')"
        />
      </div>
    </div>
    <div class="dovemed-card">
      <div class="d-flex justify-content-between notification-setting__items">
        <p class="gray900 fw700 mb-0">Likes</p>
        <a-switch
          :disabled="!permission.notifications"
          class="pl-1 pr-1"
          :style="{
            transform: 'scale(0.7)',
            'min-width': '50px',
            background: !permission.hugsLikes ? 'rgba(0,0,0,.25)' : getAlphaPrimaryColor(),
            '--P500C': getPrimaryColor().split(' ')[0],
          }"
          :checked="permission.hugsLikes"
          :loading="loading"
          @change="changePermissions($event, 'reactions')"
        />
      </div>
      <hr />
      <div class="d-flex justify-content-between notification-setting__items">
        <p class="gray900 fw700 mb-0">Post & Comment Replies</p>
        <a-switch
          :disabled="!permission.notifications"
          class="pl-1 pr-1"
          :style="{
            transform: 'scale(0.7)',
            'min-width': '50px',
            background: !permission.postCommentReplies ? 'rgba(0,0,0,.25)' : getAlphaPrimaryColor(),
            '--P500C': getPrimaryColor().split(' ')[0],
          }"
          :checked="permission.postCommentReplies"
          :loading="loading"
          @change="changePermissions($event, 'posts')"
        />
      </div>
      <hr />
      <div class="d-flex justify-content-between notification-setting__items">
        <p class="gray900 fw700 mb-0">New Messages, Mentions and Invitations</p>
        <a-switch
          :disabled="!permission.notifications"
          class="pl-1 pr-1"
          :style="{
            transform: 'scale(0.7)',
            'min-width': '50px',
            background: !permission.newMessageMentions ? 'rgba(0,0,0,.25)' : getAlphaPrimaryColor(),
            '--P500C': getPrimaryColor().split(' ')[0],
          }"
          :checked="permission.newMessageMentions"
          :loading="loading"
          @change="changePermissions($event, 'invitations')"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { RepositoryFactory } from "../../repositories/RepositoryFactory"

const UserRepository = RepositoryFactory.get("user")

export default {
  name: "NotificationSettings",
  data() {
    return {
      loading: false,
      permission: {
        notifications: false,
        hugsLikes: false,
        postCommentReplies: false,
        newMessageMentions: false,
      },
      notiKeys: ["hugsLikes", "postCommentReplies", "newMessageMentions"],
    }
  },

  mounted() {
    this.getNotificationSettings()
  },

  methods: {
    /**
     * Get Notifications Settings
     */
    getNotificationSettings() {
      this.loading = true
      UserRepository.getNotificationSettings(this.currentCircle.id)
        .then(res => {
          this.permission.notifications = res.data.data[0].allow_notifications
          this.permission.hugsLikes = res.data.data[0].reactions
          this.permission.postCommentReplies = res.data.data[0].posts
          this.permission.newMessageMentions = res.data.data[0].invitations
          this.loading = false
        })
        .catch(err => {
          this.loading = false
        })
    },

    /**
     * Change Notifications Settings
     */
    changePermissions(value, entity) {
      this.loading = true
      let numOfFalse = 0
      Object.keys(this.permission).forEach(perm => {
        if (this.notiKeys.includes(perm) && !this.permission[perm]) {
          numOfFalse += 1
        }
      })
      if (numOfFalse === 2 && !value) {
        UserRepository.changeNotificationSettings({ allow_notifications: false }, this.currentCircle.id)
          .then(res => {
            this.permission.notifications = res.data.data[0].allow_notifications
            this.permission.hugsLikes = res.data.data[0].reactions
            this.permission.postCommentReplies = res.data.data[0].posts
            this.permission.newMessageMentions = res.data.data[0].invitations
            this.loading = false
          })
          .catch(err => {
            this.loading = false
          })
      } else {
        UserRepository.changeNotificationSettings({ [entity]: value }, this.currentCircle.id)
          .then(res => {
            this.permission.notifications = res.data.data[0].allow_notifications
            this.permission.hugsLikes = res.data.data[0].reactions
            this.permission.postCommentReplies = res.data.data[0].posts
            this.permission.newMessageMentions = res.data.data[0].invitations
            this.loading = false
          })
          .catch(err => {
            this.loading = false
          })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.ant-switch::after {
  transform: scale(1.5) !important;
}

.ant-switch-checked::after {
  transform: translateX(-100%) scale(1.5) !important;
  // background-color: #2a71d4;
  background: var(--P500C);
  // background-color: var(--thumb-color);
}

.notification-setting__items {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
}

@media screen and (max-width: 600px) {
  .main-elem {
    margin-top: 24px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/account/NotificationSettings.vue